module.exports = __webpack_public_path__ + "img/homepageBannerAutumn-old.eb848afa.jpg";